<template>
  <div>
    <div v-if="isLoadingEmployee">
      <i class="el-icon-loading font-size-30 text-white mt-10" />
    </div>

    <div v-else class="detail-body">
      <div class="title-body">
        <h5 @click="backtoEmployee()">
          <i class="el-icon-arrow-left icon" />
          {{ employee.name }}{{ $t('common.employeeDetail') }}
        </h5>

        <div class="button-right">
          <el-button
            v-if="userInfo.type === ERolAdmin.ADMIN"
            class="btn"
            type="primary"
            @click="handleOpenEditDialog()"
          >
            {{ $t('employee.editBtn') }}
          </el-button>
        </div>
      </div>

      <div class="info-body">
        <el-row>
          <el-col class="info" :offset="1">
            <div class="title">{{ $t('employee.name') }}</div>
            <div class="detail">{{ employee.name }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="info" :offset="1">
            <div class="title">{{ $t('employee.email') }}</div>
            <div class="detail">
              {{ employee.email }}
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="info" :offset="1">
            <div class="title">{{ $t('employee.phone') }}</div>
            <div class="detail">{{ formatPhoneNumber(employee.phone) }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="info" :offset="1" :xs="22">
            <div class="title">{{ $t('employee.jobTitle') }}</div>
            <div class="detail">{{ employee.role }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="info" :offset="1" :xs="22">
            <div class="title">{{ $t('employee.labelStore') }}</div>
            <div class="detail">{{ employee.store.name }}</div>
          </el-col>
        </el-row>
      </div>

      <modal-edit
        :openEditDialog="openEditDialog"
        @handleCloseEditDialog="handleCloseEditDialog"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { redirectRouter, formatPhoneNumber } from '@/helper';
import * as pageRouter from '@/constants/pageRouter';
import { PAGE } from '@/constants/common';
import { ERolAdmin } from '@/enums/user';

const ModalEdit = () => import('./EditEmployeeDialog');

export default {
  components: { ModalEdit },
  data() {
    return {
      ERolAdmin,
      openEditDialog: false,
    };
  },
  computed: {
    ...mapGetters('employee', ['employee', 'isLoadingEmployee']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    formatPhoneNumber,
    ...mapActions('employee', ['getEmployeeDetail']),
    handleOpenEditDialog() {
      this.openEditDialog = true;
    },
    handleCloseEditDialog() {
      this.openEditDialog = false;
    },

    backtoEmployee() {
      redirectRouter({
        path: pageRouter.EMPLOYEE,
        query: {
          name: this.$route.query.name,
          store: this.$route.query.store,
          page: this.$route.query.page || PAGE,
        },
      });
    },
  },
  created() {
    const { id } = this.$router.currentRoute.params;

    this.getEmployeeDetail({ id });
  },
};
</script>

<style lang="scss">
@import '@/styles/common-detail.scss';
</style>
